import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner } from "react-bootstrap";
import TabCode from "./TabCode";
import TabPayment from "./TabPayment";
import { languagePayment, methodPayment } from "./json";
import axios from "axios";

const ModalListenAudio = ({
  data,
  handleShowModal,
  isShowModal,
  id,
  idLanguage,
  callbackButtonsDisabled,
  codePayment,
}) => {
  const [nameAudio, setNameAudio] = useState([]);
  const [isDisabledPayment, setIsDisabledPayment] = useState(true);
  const [textLang, setTextLang] = useState([]);
  const secondsAudio = useRef();

  useEffect(() => {
    const lang = languagePayment.filter((el) => el.id === idLanguage);
    setTextLang(lang);
  }, []);

  useEffect(() => {
    if (codePayment) {
      if (isShowModal) {
        document.getElementById("loaderSpinner").style.display = "flex";
      } else {
        document.getElementById("loaderSpinner").style.display = "none";
      }
      axios.get(`getaudiofiledata?id=${id}`).then((res) => {
        setNameAudio([]);
        const nameAudio = [];
        nameAudio.push({
          name: res.data.Name,
          dataBlob: res.data.Data,
          id: id,
          contentType: res.data.ContentType,
        });
        if (nameAudio.length !== 0) {
          document.getElementById("loaderSpinner").style.display = "none";
        }
        setNameAudio(nameAudio);
      });
    } else {
      data.filter((el) => {
        if (el.Id === id) {
          const nameAudio = [];
          nameAudio.push({
            name: el.Name,
            dataBlob: el.AudioFile.Data,
            id: el.Id,
            contentType: el.AudioFile.ContentType,
          });
          setNameAudio(nameAudio);
        }
      });
    }
  }, [isShowModal]);

  const base64ToArrayBuffer = (_base64Str) => {
    var binaryString = window.atob(_base64Str);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  const convertAudioToBlob = (content, data) => {
    var byte = base64ToArrayBuffer(data);
    let blob = new Blob([byte], { type: content });
    return URL.createObjectURL(blob);
  };

  const getSecondsAudio = () => {
    let seconds = parseInt(secondsAudio.current.currentTime);
    if (seconds >= 30 && codePayment === null) {
      setIsDisabledPayment(false);
      callbackButtonsDisabled(false);
    }
  };

  return (
    <div>
      <div id="loaderSpinner">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
      <Modal show={isShowModal} id="modalListenForPassword">
        <Modal.Body>
          {nameAudio.map((nameAudio, index) => (
            <Container key={index} className="d-flex flex-column my-2">
              <span className="my-2" style={{ fontWeight: "bold" }}>
                {nameAudio.name + ":"}
              </span>
              <audio
                id={"audio" + nameAudio.id}
                className="w-100"
                controls
                controlsList="nodownload"
                onTimeUpdate={getSecondsAudio}
                onEnded={() => {
                  setIsDisabledPayment(false);
                  callbackButtonsDisabled(false);
                }}
                ref={secondsAudio}
              >
                <source
                  src={convertAudioToBlob(
                    nameAudio.contentType,
                    nameAudio.dataBlob
                  )}
                  type={nameAudio.contentType}
                />
              </audio>
            </Container>
          ))}
          <div
            style={
              isDisabledPayment ? { display: "none" } : { display: "block" }
            }
          >
            <TabPayment idLanguage={idLanguage} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="buttons__close"
            onClick={() => handleShowModal(0, "modalListenAudio")}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalListenAudio;
